// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"59":"2acf2271b9d426d6","80":"25bab9742a63436c","121":"c17fd271c15e70ab","453":"5a4e418001987392","460":"77cbea50c7b80d6d","730":"25e908d04fc29df2","845":"d9648408055de4a8"}[chunkId] + ".js";
};